import * as React from 'react';
import Box from '@mui/material/Box';
import axios from 'axios';
import { useSelector } from 'react-redux';
import { useFormik, Form, FormikProvider } from 'formik';

import {FormGroup , FormControlLabel , Checkbox , Stack , TextField , IconButton } from '@mui/material'
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import FormControl from '@mui/material/FormControl';
import PhotoCamera from '@mui/icons-material/PhotoCamera';


const steps = ['Select a proplem', 'Provide us with an image' , 'Type a text'];

export default function ReportStepper({handleClose,fileId}) {
  const [proplemtype , setProplemtype] = React.useState({

  })
  const [description , setDescription] = React.useState('');
  const [activeStep, setActiveStep] = React.useState(0);
  const [skipped, setSkipped] = React.useState(new Set());
  const userLogin = useSelector((state) => state.userLogin);
  const { userInfo } = userLogin;
  const config = {
    headers: {
      'Content-type': 'application/json',
      Authorization: `Bearer ${userInfo?.access}`,
    },
  };

  const isStepOptional = (step) => {
    return step === 1;
  };

  const isStepSkipped = (step) => {
    return skipped.has(step);
  };
  



  const handleChange = (event) => {
    // 👇 Get input value from "event"
    setDescription(event.target.value);
  };

  const handleNext = () => {
    let newSkipped = skipped;
    if (isStepSkipped(activeStep)) {
      newSkipped = new Set(newSkipped.values());
      newSkipped.delete(activeStep);
    }

    setActiveStep((prevActiveStep) => prevActiveStep + 1);
    setSkipped(newSkipped);
  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  const handleSkip = () => {
    if (!isStepOptional(activeStep)) {
      // You probably want to guard against something like this,
      // it should never occur unless someone's actively trying to break something.
      throw new Error("You can't skip a step that isn't optional.");
    }

    setActiveStep((prevActiveStep) => prevActiveStep + 1);
    setSkipped((prevSkipped) => {
      const newSkipped = new Set(prevSkipped.values());
      newSkipped.add(activeStep);
      return newSkipped;
    });
  };

  const handleReset = () => {
    setActiveStep(0);
  };

  const handleFinish = () => {

  };


  const postReport = async () => {


    try {
      await axios.post(`${process.env.REACT_APP_API_KEY}/api/v1/reports/proplem/`, {description} , config);

      setTimeout(() => {
        // window.location.replace(`${fileSource}`);
       // window.open('');
        setActiveStep(3);

      }, 500);


      

    } catch (err) {
      console.error(err);
    }
  };


  return (
    <Box sx={{ width: '100%' }}>
      <Stepper activeStep={activeStep}>
        {steps.map((label, index) => {
          const stepProps = {};
          const labelProps = {};
          if (isStepOptional(index)) {
            labelProps.optional = (
              <Typography variant="caption">Optional</Typography>
            );
          }
          if (isStepSkipped(index)) {
            stepProps.completed = false;
          }
          return (
            <Step key={label} {...stepProps}>
              <StepLabel {...labelProps}>{label}</StepLabel>
            </Step>
          );
        })}
      </Stepper>
      {activeStep === 3? (
        <React.Fragment  key='' >
          {description.length > 5 ? (   <Typography sx={{ my:6 , mx:2 }}>
            Thanks for your time ,, we will look at your report and take action soon . 
           </Typography>):(   <Typography sx={{ my:6 , mx:2 }}>
            Please if you have a proplem with this file give us more details . 
           </Typography>)}
       
          <Box sx={{ display: 'flex', flexDirection: 'row', pt: 2 }}>
            <Box sx={{ flex: '1 1 auto' }} />
            <Button onClick={handleClose}>Done</Button>
          </Box>
        </React.Fragment>
      ) : (
        <React.Fragment  key=''>
        {/*  <Typography sx={{ mt: 2, mb: 1 }}>Step {activeStep + 1}</Typography>  */}
        <FormControl fullWidth sx={{ m: 1 }}>

        {activeStep === 0 ? (
           <FormGroup>
           <FormControlLabel control={<Checkbox  />} label="Obscene content, offensive to modesty or to the public, or contrary to religion "/>
           <FormControlLabel control={<Checkbox  />} label=" Stolen content or infringing intellectual property rights " />
           <FormControlLabel control={<Checkbox  />} label="Missing content, damaged, or contrary to description, or has problems with downloading and decompressing" />
         </FormGroup>
        ):('')}


        {activeStep === 1 ? (
             <Stack direction="column" alignItems="center" spacing={2}>
             <Typography> upload an image or an screen shoot that view the proplem can help us solve it  </Typography>
             <br/>
           <IconButton color="primary" aria-label="upload picture" component="label" >
             <input hidden accept="image/*" type="file" />
             <PhotoCamera />
           </IconButton>
         </Stack>
        ):('')}


        {activeStep === 2 ? (
           <Box
           component="form"
           sx={{
             '& .MuiTextField-root': { m: 1, width: '90%' },
           }}
           noValidate
           autoComplete="off"
         >
           <div>
          
        
             <TextField
               id="outlined-multiline-static"
               label="Type your report text ,, Type by any language ."
               multiline 
               rows={4}
               defaultValue=""
               onChange={handleChange}
     
     
             />
           </div>
           
     
         </Box>
        ):('')}

        </FormControl>
            


          <Box sx={{ display: 'flex', flexDirection: 'row', pt: 2 }}>
            <Button
              color="inherit"
              disabled={activeStep === 0}
              onClick={handleBack}
              sx={{ mr: 1 }}
            >
              Back
            </Button>
            <Box sx={{ flex: '1 1 auto' }} />
            {isStepOptional(activeStep) && (
              <Button color="inherit" onClick={handleSkip} sx={{ mr: 1 }}>
                Skip
              </Button>
            )}




      {activeStep === steps.length - 1 && description.length > 5 ? (
            <Button disabled={description.length < 5} onClick={() => {postReport();handleFinish()} }>
              Send report
            </Button>
      ):( 
        <Button onClick={handleNext}>
        Next
      </Button>
      )}
        </Box>
        </React.Fragment>
      )}
    </Box>
  );
}